import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Image from 'mui-image';

import sponsorUoN from '../assets/base/sponsor.uon.png';
import sponsorEwi from '../assets/base/sponsor.ewi.png';

export default function SponsorFooter() {
  return (
    <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Supported by
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Image src={sponsorUoN} width={120} duration={0} />
        <Image src={sponsorEwi} width={60} duration={0} />
      </Box>
    </Box>
  );
}
